export default __webpack_public_path__ + "static/drug_discovery-1fffe0896229eeedea9bcefd7da4e0e7.png";